import { createMuiTheme, colors } from "@material-ui/core";
import shadows from "./shadows";
import typography from "./typography";
import hertzColors from "./colors";

const getPrimaryColorByBrand = (brand) => {
  switch (brand) {
    case "Ace":
      return {
        main: hertzColors.ace,
        hover: hertzColors.aceHover,
        text: hertzColors.aceText,
      };
    case "Firefly":
      return {
        main: hertzColors.firefly,
        hover: hertzColors.fireflyHover,
        text: hertzColors.fireflyText,
      };
      case "Dollar":
        return {
          main: hertzColors.dollar,
          hover: hertzColors.dollarHover,
          text: hertzColors.dollarText
        };
      case "Thrifty":
        return {
          main: hertzColors.thrifty,
          hover: hertzColors.thriftyHover,
          text: hertzColors.thriftyText
        };
    default:
      return {
        main: hertzColors.hertz,
        hover: hertzColors.hertzHover,
        text: hertzColors.ninetyBlack,
      };
  }
};

const getThemeByBrand = (brand) => {
  const { main, hover, text } = getPrimaryColorByBrand(brand);
  return createMuiTheme({
    palette: {
      background: {
        dark: "#282C34",
        default: colors.common.white,
        paper: colors.common.white,
      },
      primary: {
        main,
        hover,
        text,
      },
      secondary: {
        main: colors.indigo[500],
      },
      text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600],
      },
    },
    overrides: {
      MuiTimelineItem: {
        missingOppositeContent: {
          "&:before": {
            display: "none",
          },
        },
      },
    },
    hertzColors,
    shadows,
    typography,
  });
};

export default getThemeByBrand;
